import { useState, useCallback, useRef, useEffect } from 'react';
import { debounce } from 'lodash';

import { dadataRequest } from 'data-providers/dadataProvider';

export const useDaDataPresenter = ({
  type,
  name,
  additionalData,
  value,
  onChange,
  onBlur,
  resultsCount,
  debounce: debounceTimeout,
  mask,
}) => {
  const inputRef = useRef();
  const dropDownRef = useRef();
  const [localValue, setLocalValue] = useState(value);
  const [suggestions, setSuggestions] = useState([]);

  const presenter = {
    inputRef,
    localValue,
    dropDownRef,
    suggestions,
    setSuggestions,

    get isDropDownShown() {
      return presenter.suggestions.length > 0;
    },

    outsideClickHandler(e) {
      if (e?.target && dropDownRef.current && dropDownRef.current.contains(e.target)) {
        return;
      }
      setSuggestions([]);
    },

    suggestionClickHandler(item) {
      onChange(name ? { [name]: item } : item);
      setSuggestions([]);
    },

    changeHandler(e) {
      const newVal = mask ? e : e.target.value;
      if (newVal && newVal !== localValue) {
        fetchSuggestions(type, newVal, resultsCount, additionalData);
      } else {
        setSuggestions([]);
      }
      setLocalValue(newVal);
      onChange(name ? { [name]: newVal } : { value: newVal });
    },

    blurHandler() {
      onBlur();
    },
  };

  const fetchSuggestions = useCallback(
    debounce((type, query, count, additionalData) => {
      dadataRequest(type, query, count, additionalData).then((data) => {
        presenter.setSuggestions(data);
      });
    }, debounceTimeout),
    []
  );

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return presenter;
};
